import axios from "axios";
import credentials from "../assets/credentials";
const API_BASE_URL = credentials.BASE_URL;

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Automatically add token to requests (if available)
apiClient.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("token"));
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

//api call template for simpler call
async function apiCallTemplate(reqType, callURL, reqBody,){
        try {
           const response = await apiClient[reqType](callURL, reqBody||null);
        return response.data;
        } catch (error) {
          if(error.status >= 400 && error.response.data.message ){
            throw new Error(error.response?.data?.message);
          }else{
            console.log(error)
            throw new Error("");
          }
        }
}

export default apiCallTemplate;
